import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { IGameStateMachineProvider } from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import {
  GAME_STATE_MACHINE_TOKEN,
  GameStateMachine,
} from '../../reels_engine/state_machine/game-state-machine';

/**
 * @deprecated get gameStateMachine directly from DI using "GAME_STATE_MACHINE_TOKEN" token
 */
export class GameStateMachineProvider implements IGameStateMachineProvider {
  private readonly _stateMachine: GameStateMachine<SpinResponse>;

  constructor(container: Container) {
    this._stateMachine =
      container.resolve<GameStateMachine<SpinResponse>>(GAME_STATE_MACHINE_TOKEN);
  }

  /**
   * @deprecated get gameStateMachine directly from DI using "GAME_STATE_MACHINE_TOKEN" token
   */
  public get gameStateMachine(): GameStateMachine<SpinResponse> {
    return this._stateMachine;
  }

  public deinitialize(): void {
    this._stateMachine.interrupt();
  }
}
